import ActionButton from './ActionButton.jsx';

// T270(4) / T161 — the four triage buttons, written once.
//
// They existed twice: once in AvailableCard (mobile) and once in AvailableRow
// (desktop). T256 spelled out the desktop titles so a tooltip stopped being a
// bare keystroke — and only the desktop copy. The two then said different
// things about the same state:
//
//   shortlisted    card: "Shortlist  (s)"          row: "Remove from shortlist (s)"
//   an explanation card: "Explain with Claude  (e)" row: "Re-run AI explanation (e)"
//
// So on a phone the button announced "Shortlist" for a job already shortlisted,
// and "Explain with Claude" for one already explained. The row's behaviour is
// the correct one — a title that reports the state it is in — so that is what
// both get here. (The card's strings also carried a double space, which is why
// they read oddly next to their siblings.)
export default function RecActions({
  rec, shortlisted, explained, pending, explainPending, onUpdate, onExplain, onRequestDismiss,
}) {
  return (
    <>
      <ActionButton
        active={shortlisted}
        disabled={pending}
        onClick={() => onUpdate(rec.id, shortlisted ? 'new' : 'shortlisted')}
        title={shortlisted ? 'Remove from shortlist (s)' : 'Shortlist (s)'}
      >
        {shortlisted ? '✓ Shortlisted' : 'Shortlist'}
      </ActionButton>
      <ActionButton disabled={pending} onClick={() => onUpdate(rec.id, 'applied')} title="Mark as applied (a)">
        Apply
      </ActionButton>
      <ActionButton
        disabled={pending}
        onClick={() => (onRequestDismiss ? onRequestDismiss(rec) : onUpdate(rec.id, 'dismissed'))}
        title={onRequestDismiss ? 'Dismiss with a reason… (d dismisses instantly)' : 'Dismiss (d)'}
      >
        Dismiss
      </ActionButton>
      <ActionButton
        disabled={pending || explainPending}
        onClick={() => onExplain(rec.id)}
        title={explained ? 'Re-run AI explanation (e)' : 'Get AI explanation (e)'}
      >
        {explainPending ? '…' : explained ? '✨' : '✨ Explain match'}
      </ActionButton>
    </>
  );
}
